import React, { useEffect, useState } from 'react';
import '../../styles/MarketMarquee.css';

const fallbackItems = [
  { name: 'Bitcoin', ticker: 'BTC', price: 67500, percentChange: '2.45' },
  { name: 'Ethereum', ticker: 'ETH', price: 3450, percentChange: '1.82' },
  { name: 'Solana', ticker: 'SOL', price: 178, percentChange: '5.21' },
  { name: 'Cardano', ticker: 'ADA', price: 0.62, percentChange: '-1.15' },
  { name: 'Ripple', ticker: 'XRP', price: 0.58, percentChange: '0.95' },
  { name: 'Dogecoin', ticker: 'DOGE', price: 0.16, percentChange: '3.45' },
  { name: 'Polkadot', ticker: 'DOT', price: 8.25, percentChange: '-2.10' },
  { name: 'Avalanche', ticker: 'AVAX', price: 42.50, percentChange: '4.30' },
];

const MarketMarquee = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchCryptoData = async () => {
      try {
        const res = await fetch(
          'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=30&page=1&sparkline=false'
        );
        if (!res.ok) throw new Error('API error');
        const data = await res.json();

        const formatted = data.map(coin => ({
          name: coin.name,
          ticker: coin.symbol.toUpperCase(),
          price: coin.current_price,
          percentChange: coin.price_change_percentage_24h?.toFixed(2) || '0.00',
        }));

        setItems(formatted);
      } catch (err) {
        console.error('Error fetching crypto data:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchCryptoData();
  }, []);

  if (loading) {
    return (
      <div className="market-marquee-container">
        <div className="market-marquee-loading">Loading market data...</div>
      </div>
    );
  }

  if (error || items.length === 0) {
    const displayItems = fallbackItems;
    const loopItems = [...displayItems, ...displayItems];
    return (
      <div className="market-marquee-container">
        <div className="market-marquee">
          {loopItems.map((item, index) => (
            <div key={index} className="marquee-card">
              <div className="stock-name">
                {item.name}{' '}
                <span className={parseFloat(item.percentChange) >= 0 ? 'green' : 'red'}>
                  ({item.percentChange}%)
                </span>
              </div>
              <div className="stock-price">
                {item.ticker} | ${item.price?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const loopItems = [...items, ...items];

  return (
    <div className="market-marquee-container">
      <div className="market-marquee">
        {loopItems.map((item, index) => (
          <div key={index} className="marquee-card">
            <div className="stock-name">
              {item.name}{' '}
              <span className={parseFloat(item.percentChange) >= 0 ? 'green' : 'red'}>
                ({item.percentChange}%)
              </span>
            </div>
            <div className="stock-price">
              {item.ticker} | ${item.price?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketMarquee;
